import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

/** One stage assignee: Role or named User (Review 2 may be disabled). */
export default function ApprovalStageFields({
  title, hint, value, onChange, roles = [], users = [], optional = false,
}) {
  const v = value || { assignee_type: 'role', role_key: '', user_id: '', user_name: '', enabled: true };
  const set = (patch) => onChange({ ...v, ...patch });
  const enabled = optional ? Boolean(v.enabled) : true;

  return (
    <div className="rounded-2xl border border-[#D5DEE8] bg-white p-4 space-y-3" data-testid={`approval-stage-${title}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <h3 className="text-sm font-semibold text-[#071B34]">{title}</h3>
          {hint ? <p className="text-[11px] text-[#7A8B9C] mt-0.5">{hint}</p> : null}
        </div>
        {optional ? (
          <label className="flex items-center gap-2 text-xs font-medium text-[#071B34]">
            <input
              type="checkbox"
              checked={enabled}
              onChange={(e) => set({ enabled: e.target.checked })}
            />
            Enabled
          </label>
        ) : null}
      </div>
      {enabled ? (
        <>
          <div>
            <Label className="text-xs">Assign by</Label>
            <Select value={v.assignee_type || 'role'} onValueChange={(t) => set({ assignee_type: t })}>
              <SelectTrigger className="mt-1 bg-white"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="role">Role</SelectItem>
                <SelectItem value="user">User name</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {(v.assignee_type || 'role') === 'role' ? (
            <div>
              <Label className="text-xs">Role</Label>
              <Select
                value={v.role_key || ''}
                onValueChange={(rk) => {
                  const r = roles.find((x) => x.role_key === rk);
                  set({
                    role_key: rk,
                    role_code: r?.code || '',
                    user_id: '',
                    user_name: '',
                  });
                }}
              >
                <SelectTrigger className="mt-1 bg-white"><SelectValue placeholder="Select role" /></SelectTrigger>
                <SelectContent>
                  {roles.map((r) => (
                    <SelectItem key={r.role_key} value={r.role_key}>{r.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          ) : (
            <div>
              <Label className="text-xs">User</Label>
              <Select
                value={v.user_id || ''}
                onValueChange={(id) => {
                  const u = users.find((x) => x.id === id);
                  set({ user_id: id, user_name: u?.name || '', role_key: '', role_code: '' });
                }}
              >
                <SelectTrigger className="mt-1 bg-white"><SelectValue placeholder="Select user" /></SelectTrigger>
                <SelectContent>
                  {users.map((u) => (
                    <SelectItem key={u.id} value={u.id}>{u.name}{u.clinic_role ? ` · ${u.clinic_role}` : ''}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {v.user_name ? <Input className="mt-2 bg-stone-50" readOnly value={v.user_name} /> : null}
            </div>
          )}
        </>
      ) : (
        <p className="text-xs text-[#7A8B9C]">Skipped — this stage is not used in the approval flow.</p>
      )}
    </div>
  );
}
